import { useContext } from "react";
import { ThemeModeContext } from "../contexts/ThemeModeContext";

export const useThemeMode = () => {
    return useContext(ThemeModeContext);
}